import CheckboxList from "./CheckboxList";

export default CheckboxList;
